"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _FunnelTime = _interopRequireDefault(require("@rsuite/icon-font/lib/charts/FunnelTime"));

// Generated by script, don't edit it please.
var FunnelTime = (0, _createSvgIcon["default"])({
  as: _FunnelTime["default"],
  ariaLabel: 'funnel time',
  category: 'charts',
  displayName: 'FunnelTime'
});
var _default = FunnelTime;
exports["default"] = _default;
module.exports = exports.default;